export const initialWishlistState = {
  products: [],
  total: 0
}

function getWishlistTotal(products) {
  return products.reduce((sum, p) => sum + p.price * p.quantity, 0)
}

export default function wishlistReducer(state, action) {
  let newProducts
  
  switch(action.type) {
    case "RESET_LIST":
      return initialWishlistState

    case "SET_PRODUCTS_LIST":
      return {
        ...state, 
        products: action.payload,
        total: getWishlistTotal(action.payload),
      }

    case "ADD_PRODUCTS_LIST":
      newProducts = [
        ...state.products, 
        ...action.payload.map(product => ({
          ...product,
          id: product._id,  
          itemId:product.itemId,       
          title: product.iName,
          price: product.tranRate,
          image: product.imgPath,
          // quantity: product.quantity,
          // taxId: product.taxId,
          // taxLedId: product.taxLedId,
          // taxOn: product.taxOn,
          // taxRate: product.taxRate,
        })),
      ]

      return {
        ...state,
        products: newProducts,
        total: getWishlistTotal(newProducts)
      }

    case "REMOVE_PRODUCT_LIST":
      newProducts = state.products.filter(p => p.id !== action.payload)

      return {
        ...state, 
        products: newProducts,
        total: getWishlistTotal(newProducts),
      }

    case "SET_PRODUCT_QUANTITY_LIST":
      if (action.payload.quantity < 1) {
        return state
      }
      newProducts = [...state.products]
      const productIdx = newProducts.findIndex(p => p.id === action.payload.id)
      newProducts[productIdx].quantity = action.payload.quantity

      return {
        ...state,
        products: newProducts,
        total: getWishlistTotal(newProducts),
      }

    default:
      return state
  }
}